
import { isDesktop, isPortrait } from '@/helpers/ui.helpers'


const layoutStore = {
	namespaced: true,
	state: {
		showMenu: false,
		changeUserModalVisible: false
	},
	mutations: {
		toggleChangeUserModalVisible (state) {
			state.changeUserModalVisible = !state.changeUserModalVisible
		}
	},
	getters: {
		isToggleable () {
			return !isDesktop || isPortrait
		}
	},
	actions: {
		init ({ dispatch }) {
			dispatch('notifications/getSummary', null, { root: true })
		},
		toggleMenu ({ state, getters }) {
			if (getters.isToggleable) {
				state.showMenu = !state.showMenu
			}
		},
		hideMenu ({ state }) {
			state.showMenu = false
		}
	}
}

export default layoutStore


// WEBPACK FOOTER //
// ./src/store/modules/layout.js